import { z } from 'zod';

// ---------------------------------------------------------------------------
// Outbound Schema
// ---------------------------------------------------------------------------

export const outboundSchemaQuery = z.object({
  type: z.enum(['whatsapp', 'email', 'app', 'all']).default('all'),
});

// ---------------------------------------------------------------------------
// Template Params & Queries
// ---------------------------------------------------------------------------

export const templateIdParam = z.object({
  id: z.string().uuid(),
});

export const listTemplatesQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const deleteTemplateQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const templateStatusQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const createTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();

export const updateTemplateBody = z.object({}).passthrough();

export const submitTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();

export const testTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

/** Connection entry in the outbound schema */
export interface OutboundSchemaConnection {
  connection_id: string;
  connector_name: string;
  connection_display_name?: string;
  connector_type: string;
  service_name: string;
  hub_id: string;
  enabled: boolean;
}

/** GET /schema */
export interface GetOutboundSchemaResponse {
  data: {
    flat: {
      organizations: Array<{
        organization_id: string;
        organization_name: string;
      }>;
      hubsByOrg: Record<string, Array<{
        hub_id: string;
        hub_name: string;
      }>>;
      connectionsByHub: Record<string, OutboundSchemaConnection[]>;
    };
    lastUpdated: string;
  };
}
